import { Injectable } from "@angular/core"
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from "@angular/router"
import { Observable } from "rxjs"
import { WebLogger } from "@weps/shared-http"

export class Permissions {
  canActivate(): boolean {
    return true
  }
}

@Injectable({
  providedIn: "root",
})
export class Auth0Guard implements CanActivate {
  //temporary, I'm just testing separation of auth depending on env
  constructor(private permissions: Permissions) {}
  canActivate(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    route: ActivatedRouteSnapshot,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.permissions.canActivate()
  }
}
